// 主管账号 mock 数据
// 与 employees 通过 email 一对一关联
// 前端-only 实现，通过 localStorage 持久化

export const defaultUsers = [
  {
    email: 'zhangsan@company.com',
    password: 'zhangsan@company.com',
    role: 'manager',
    status: 'normal',
    is_first_login: false
  },
  {
    email: 'zhaoliu@company.com',
    password: 'zhaoliu@company.com',
    role: 'manager',
    status: 'normal',
    is_first_login: true
  },
  {
    email: 'zhoujiu@company.com',
    password: 'zhoujiu@company.com',
    role: 'manager',
    status: 'normal',
    is_first_login: true
  },
  {
    email: 'zhengshiyi@company.com',
    password: 'zhengshiyi@company.com',
    role: 'manager',
    status: 'normal',
    is_first_login: false
  },
  {
    email: 'zhushiliu@company.com',
    password: 'zhushiliu@company.com',
    role: 'manager',
    status: 'normal',
    is_first_login: true
  },
  {
    email: 'linshiqi@company.com',
    password: 'linshiqi@company.com',
    role: 'manager',
    status: 'normal',
    is_first_login: true
  },
  {
    email: 'luoshijiu@company.com',
    password: 'luoshijiu@company.com',
    role: 'manager',
    status: 'normal',
    is_first_login: true
  },
  {
    email: 'wangzhiyuan@company.com',
    password: 'wangzhiyuan@company.com',
    role: 'manager',
    status: 'normal',
    is_first_login: false
  }
]

export function getStoreUsers() {
  const s = require('../store').default
  return s.state.employees && s.state.employees.users && s.state.employees.users.length
    ? s.state.employees.users
    : defaultUsers
}
